// app/javascript/api/notifications.js
import { defaultServerErrorMessage, isProduction } from "../utils/constants";
import { bugsnag_log } from "../utils/bugsnag";

export const getUserNotificationsPage = async ({ limit = 30, offset = 0, unreadOnly = false } = {}) => {
  const body = JSON.stringify({
    query: `
      query($limit: Int!, $offset: Int!, $unreadOnly: Boolean!) {
        userNotifications(limit: $limit, offset: $offset, unreadOnly: $unreadOnly) {
          id title text body kind actionUrl metadata seenAt readAt createdAt updatedAt
        }
      }
    `,
    variables: { limit, offset, unreadOnly },
  });

  try {
    const res = await fetch("/graphql", { method: "POST", headers: { "Content-Type": "application/json" }, body });
    const json = await res.json();
    if (json.errors?.length) throw new Error(json.errors[0].message || defaultServerErrorMessage);
    return json.data.userNotifications ?? [];
  } catch (e) {
    if (!isProduction) console.error("getUserNotificationsPage", e);
    bugsnag_log(e);
    return { error: defaultServerErrorMessage };
  }
};

export const getUnreadNotificationCount = async () => {
  const body = JSON.stringify({ query: `{ userNotificationUnreadCount }` });
  try {
    const res = await fetch("/graphql", { method: "POST", headers: { "Content-Type": "application/json" }, body });
    const json = await res.json();
    if (json.errors?.length) throw new Error(json.errors[0].message || defaultServerErrorMessage);
    return json.data.userNotificationUnreadCount ?? 0;
  } catch (e) {
    if (!isProduction) console.error("getUnreadNotificationCount", e);
    bugsnag_log(e);
    return 0;
  }
};

export const markNotificationSeen = async (id) => {
  const body = JSON.stringify({
    query: `
      mutation($input: MarkUserNotificationSeenInput!) {
        markUserNotificationSeen(input: $input) { status }
      }
    `,
    variables: { input: { id } },
  });

  const res = await fetch("/graphql", { method: "POST", headers: { "Content-Type": "application/json" }, body });
  const json = await res.json();
  if (json.errors?.length) throw new Error(json.errors[0].message || defaultServerErrorMessage);
  return json.data?.markUserNotificationSeen?.status === "200";
};

// export const markNotificationRead = async (id) => {
//   console.log("Marking read!")
//   const body = JSON.stringify({
//     query: `
//       mutation($input: MarkUserNotificationReadInput!) {
//         markUserNotificationRead(input: $input) { status }
//       }
//     `,
//     variables: { id },
//   });
//   const res = await fetch("/graphql", { method: "POST", headers: { "Content-Type": "application/json" }, body });
//   const json = await res.json();
//   console.log("?json?", json)
//   if (json.errors?.length) throw new Error(json.errors[0].message || defaultServerErrorMessage);
//   return json.data?.markUserNotificationRead?.status === "200";
// };